'use strict';
import loadScript from "../js/scripts/loadScript";
import loadCSS from "../js/scripts/loadCSS";

export default function (opt) {
    let dns = opt.dns;
    let appVersion = opt.appVersion;
    let galleries = {};
    window.galleries = galleries;
    let gallerySelector  = 'div[id*="additonal-photo-gallery-"].photo-gallery:not(.ug-gallery-wrapper)';
    let galleryList = document.querySelectorAll(gallerySelector);

    if (galleryList.length >= 1) {
        if ('IntersectionObserver' in window) {
            let target = galleryList[0].previousElementSibling !== null ? galleryList[0].previousElementSibling : galleryList[0];
            if (target.tagName.toLowerCase() === 'script') target = galleryList[0];
            let io = new IntersectionObserver(entries => {
                    if (entries[0].isIntersecting) {
                        initAllGalleryDependencies();
                        io.unobserve(target)
                    }
                },
                {}
            );
            io.observe(target);
        } else {
            initAllGalleryDependencies();
        }
    }

    function initAllGalleryDependencies() {
        cleanGalleryContent(gallerySelector);
        loadCSS(dns + 'assets/tv24/lib/unitegallery/css/main_gallery.min.css?v=' + appVersion)
        let script = loadScript(dns + 'assets/tv24/lib/unitegallery/js/gallery_main.min.js?v=' + appVersion);
        script.onload = function (){
            initGallery(galleryList);
        }
    }

    function cleanGalleryContent(gallerySelector) {
        $(gallerySelector).find('noscript').remove();
        $(gallerySelector).find('script').remove();
    }

    function initGallery(galleryList) {
        galleryList.forEach(item => {
            let photoGalleryCfg = {
                /*thumb style begin*/
                thumb_border_effect: false,
                thumb_color_overlay_effect: true,
                thumb_overlay_color: "#ffffff",
                thumb_overlay_reverse: false,
                thumb_overlay_opacity: 0.4,
                /*thumb style end*/
                theme_hide_panel_under_width: 480,          //hide panel under certain browser width, if null, don't hide

                slider_scale_mode: "fit",                  //scale mode for main image in gallery
                slider_scale_mode_fullscreen: "full",       //fit, down, full scale mode on fullscreen.
                slider_loader_type: 7,                      //shape of the loader (1-7)
                slider_controls_always_on: true,            //hide controls
                slider_progress_indicator_type: "bar",     //progress bar type
                slider_progressbar_color: "#333"             //progress bar color
            };

            let galleryName = item.id;
            let gallerySelector = '#' + galleryName;

            galleries[galleryName] = $(gallerySelector).unitegallery(photoGalleryCfg);

            $(gallerySelector + " > div.ug-top-right-wraper > div.ug-default-button-play").click(function () {
                $(this).toggleClass("ug-stop-mode");
                galleries[galleryName].togglePlay();
            });

            $(gallerySelector + " > div.ug-top-right-wraper > div.ug-default-button-fullscreen").click(function () {
                galleries[galleryName].toggleFullscreen();

            });

            // Fix showing thumbnails
            if (typeof galleries[galleryName] != 'undefined') {
                galleries[galleryName].resize(document.getElementById(galleryName).offsetWidth - 1);
            }
        })
    }
}